import { createContext } from 'react';

import { WildCardItemInfo } from 'src/types/WildCardItemInfo';

type WildCardRouteState = {
	wildCardItemInfo: WildCardItemInfo | undefined;
	updateWildCardItemInfo: (wildCardItemInfo: WildCardItemInfo | undefined) => void;
};

export const defaultWildCardRouteState: WildCardRouteState = {
	wildCardItemInfo: undefined,
	updateWildCardItemInfo: (wildCardItemInfo: WildCardItemInfo | undefined) =>
		console.log(`Default updateWildCardItemInfo: ${wildCardItemInfo}`),
};

export const WildCardRouteContext = createContext<WildCardRouteState>(defaultWildCardRouteState);
